module.exports = __webpack_public_path__ + "lp/img/check_gray.0592de18.svg";